export default __webpack_public_path__ + "static/media/warning.11a6b645.svg";